import React from 'react';
import NewsContainer from './NewsContainer';

class NewsScreen extends React.Component {

    public render() {
        return <NewsContainer />
    }

}

export default NewsScreen;